
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Upload } from "lucide-react";

interface PhotoUploadProps {
  photoPreview: string | null;
  getInitials: (firstName: string, lastName: string) => string;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  firstName: string;
  lastName: string;
  hasExistingPhoto: boolean;
}

const PhotoUpload: React.FC<PhotoUploadProps> = ({
  photoPreview,
  getInitials,
  handleFileChange,
  firstName,
  lastName,
  hasExistingPhoto
}) => {
  return (
    <div className="flex justify-center mb-4">
      <div className="flex flex-col items-center gap-2">
        <Avatar className="h-24 w-24">
          <AvatarImage src={photoPreview || ''} />
          <AvatarFallback className="text-lg">
            {getInitials(firstName, lastName)}
          </AvatarFallback>
        </Avatar>
        
        <div className="relative">
          <Input
            type="file"
            accept="image/*"
            className="hidden"
            id="profile-photo"
            onChange={handleFileChange}
          />
          <label htmlFor="profile-photo">
            <Button 
              type="button" 
              variant="outline" 
              className="text-xs" 
              size="sm"
              onClick={() => document.getElementById('profile-photo')?.click()}
            >
              <Upload className="h-3 w-3 mr-1" />
              {hasExistingPhoto ? 'Change Photo' : 'Upload Photo'}
            </Button>
          </label>
        </div>
      </div>
    </div>
  );
};

export default PhotoUpload;
